import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import CoverageOption from './CoverageOption';

const mapStateToProps = ({User, Noyo}) => {
    return {
        currentUser: User.currentUser,
        carriers: Noyo.carriers
    }
};

const mapDispatchToProps = {};

const ConnectedCoverageOption = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
        forwardRef: true,
    },
)(CoverageOption);

export default forwardRef((props, ref) => {
    return <ConnectedCoverageOption {...props} ref={ref} />
})